import React from 'react';
import { FireIcon } from '@heroicons/react/24/outline';
import { PlayerWinStreakPayload } from '../../../generated-api';
import { CompactEventRow } from './CompactEventRow';

interface PlayerWinStreakCardProps {
  payload: PlayerWinStreakPayload;
  createdAt: string;
}

export const PlayerWinStreakCard: React.FC<PlayerWinStreakCardProps> = ({ payload, createdAt }) => (
  <CompactEventRow
    track="feed_win_streak_card"
    to={`/players/${payload.playerId}`}
    icon={<FireIcon className="h-4 w-4" />}
    iconClassName="bg-orange-100 text-orange-600"
    label="Win Streak"
    createdAt={createdAt}
  >
    <span className="font-medium text-heading">{payload.playerName}</span>
    {' won '}
    <span className="font-semibold text-orange-700">{payload.streakCount} in a row</span>
  </CompactEventRow>
);
